<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.leaveRecord.leaveRecord') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <ts-button color="info" outline @click="$router.push({ name: 'leave-record-create' })">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end"></div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
            <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
          <a-drawer :title="$t('invoice.filter')" placement="right" :closable="false" :visible="visible"
            @close="() => (visible = false)" :zIndex="1020" width="300px">
            <div style="font-size: 12px">
              <div class="row">
                <div class="form-group">
                  <label class="control-label">
                    {{
                      $t(
                        'administration.employee.leaveRecord.department'
                      )
                    }}</label>
                  <div>
                    <a-select v-model="model.department_id" :options="departments" @change="departmentOptions"
                    :placeholder="$t('all')"
                      style="width: 250px" showSearch mode="multiple" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " :maxTagCount="1"></a-select>
                  </div>
                </div>
              </div>
              <div class="row ts-mt-3">
                <div class="form-group">
                  <label class="control-label">
                    {{
                      $t(
                        'administration.employee.leaveRecord.branch'
                      )
                    }}</label>
                  <div>
                    <a-select v-model="model.branch_id" :options="branchs" @change="branchOptions"
                    :placeholder="$t('all')"
                      style="width: 250px" showSearch mode="multiple" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " :maxTagCount="1"></a-select>
                  </div>
                </div>
              </div>
            </div>
          </a-drawer>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{
          field: 'leave_type_name'
        }">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{
                record.employee.branch
                ? record.employee.branch.branch_name_en : ''
              }}
            </td>
            <td class="with-img">
              <img class="height-30 ts-rounded" :src="photoEmp(record)" @error="onError(record)" />
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.employee.department ? record.employee.department.department_name_en : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.employee
                ? record.employee.name_en + '|' + record.employee.name_kh
                : ''
              }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.date_from }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.time_from_show }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.date_to }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.time_to_show }}
            </td>
            <td class="text-center ts-whitespace-no-wrap">
              {{ record.total_day_show }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.leave_reason }}</td>
            <td class="text-center ts-whitespace-no-wrap">
              <a href="#" v-tooltip="$t('tooltip.edit')" class="mr-2 text-primary" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a href="#" v-tooltip="$t('tooltip.delete')" class="text-danger" @click.prevent="showForm(record)"
                :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './delete-form.vue'

export default {
  name: 'leave-record',
  components: { FormComponent },
  data() {
    return {
      loading: false,
      visible: false,
      departments: [],
      branchs: [],
      model: {
        department_id: [],
        branch_id: [this.$store.state.authUser.default_branch_id],
      },
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png')
    }
  },
  computed: {
    ...mapState('leaveRecord', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.leaveRecord.search
      },
      set(newValue) {
        this.$store.commit('leaveRecord/SET_SEARCH', newValue)
        this.$store.commit('leaveRecord/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('administration.employee.leaveRecord.branch') },
        { name: this.$t('administration.employee.leaveRecord.employeePhoto') },
        {
          name: this.$t('administration.employee.leaveRecord.department')
        },
        {
          name: this.$t('administration.employee.leaveRecord.employeeName')
        },
        {
          name: this.$t('administration.employee.leaveRecord.dateFrom'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.timeFrom'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.dateTo'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.timeFrom'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.totalLeave'),
          style: 'text-align:center'
        },
        {
          name: this.$t('administration.employee.leaveRecord.leaveReason')
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:1%'
        }
      ]
    }
  },
  created() {
    this.fetchData()
    this.getDepartment()
    this.getBranch()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('leaveRecord/fetch',
          Object.assign(
            {},
            this.model,
            {
              department_id: this.model.department_id,
              branch_id: this.model.branch_id
            },
            { ...attributes }
          ))
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getDepartment() {
      this.$store
        .dispatch('leaveRecord/getDepartment')
        .then(response => {
          this.departments = response.data.map(el => ({
            value: el.department_id,
            label: el.department_name_en
          }))
        })
    },
    getBranch() {
      this.$store
        .dispatch('leaveRecord/getBranch')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    departmentOptions(value) {
      this.$store.commit('leaveRecord/SET_DEPARTMENT_ID', value)
      this.fetchData()
    },
    branchOptions(value) {
      this.$store.commit('leaveRecord/SET_BRANCH_ID', value)
      this.fetchData()
    },
    edit(record) {
      this.$store.commit('leaveRecord/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'leave-record-edit',
        params: { id: record.lr_id }
      })
    },
    showForm(data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('leaveRecord/destroy', record.lr_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    photoEmp(record) {
      if (record.employee.photo) {
        return record.employee.photo
      }

      return record.employee.sex == 1 ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event.target.src =
        record.employee.sex == 1 ? this.manPhoto : this.womenPhoto
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    department_id: debounce(function () {
      this.fetchData()
    }, 500),
    branch_id: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'leave-record-create') {
      this.$store.commit('leaveRecord/RESET_STATE')
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: #ffff;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
